<template>
  <div class="my-item round-corner">
    <div class="hd">
      <h3 class="title van-multi-ellipsis--l2">{{ item.typename + item.bname }}</h3>
      <span class="time">{{ formatDateTimeToNow(receive ? item.tododate : item.senddate) }}前</span>
    </div>
    <div class="num-wrap">
      <template v-if="receive">
        <div class="num-item" @click="locationTo(item.todo_mobile_url)">
          <h4 class="num-todo">{{ item.todo }}</h4>
          <p>待办事项</p>
        </div>
        <div class="num-item" @click="locationTo(item.done_mobile_url)">
          <h4 class="num-done">{{ item.done }}</h4>
          <p>已办事项</p>
        </div>
        <div class="num-item" @click="locationTo(item.copy_mobile_url)">
          <h4 class="num-copy">{{ item.copy }}</h4>
          <p>抄送给我</p>
        </div>
      </template>
      <template v-else>
        <div class="num-item" @click="locationTo(item.ongoing_mobile_url)">
          <h4 class="num-ongoing">{{ item.ongoing }}</h4>
          <p>进行中</p>
        </div>
        <div class="num-item" @click="locationTo(item.end_mobile_url)">
          <h4 class="num-end">{{ item.end }}</h4>
          <p>已结束</p>
        </div>
        <div class="num-item" @click="locationTo(item.draft_mobile_url)">
          <h4 class="num-draft">{{ item.draft }}</h4>
          <p>草稿箱</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {formatDateTimeToNow} from "@/utils/dateTimeUtil"
import {locationTo} from "@/utils/url";
export default {
  name: 'MyItem',
  components: {},
  data() {
    return {}
  },
  computed: {},
  props: ['item', 'receive', 'localType'],
  mounted() {
  },
  methods: {
    formatDateTimeToNow,locationTo
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
.my-item {
  position: relative;
  background-color: #ffffff;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  .hd {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;

    .title {
      line-height: 1.2em;
      color: #333;
      font-weight: 400;
      @extend .font14;
    }

    .time {
      border-radius: 50px;
      padding: 2px 8px;
      color: #999;
      flex-shrink: 0;
      margin-left: 15px;
      user-select: none;
      @extend .font12;
    }
  }

  .num-wrap {
    display: flex;
    justify-content: space-around;

    .num-item {
      text-align: center;
      padding: 10px 0;
      flex-grow: 1;

      h4 {
        font-weight: normal;
        line-height: 24px;
        user-select: none;
        @extend .font16;
      }

      p {
        color: #666;
        -webkit-user-select: none;
        user-select: none;
        @extend .font12;
      }
    }

    .num-item:active {
      background: #f2f3f5;
    }

    .transfer-box {
      flex: 1;
      padding: 10px 0;
      @extend .font14;
    }
  }


  .num-todo {
    color: #ef4f4f;
  }

  .num-done {
    color: #04be02;
  }

  .num-copy {
    color: #ffbe00;
  }

  .num-ongoing {
    color: #007aff;
  }

  .num-end {
    color: #04be02;
  }

  .num-draft {
    color: #ffbe00;
  }
}

.my-item:before {
  position: absolute;
  left: 0;
  top: 10px;
  content: "";
  display: block;
  width: 6px;
  height: 22px;
  border-radius: 0 2px 2px 0;
  background: #efefef;
}
</style>
